// src/api/apiAdmin.jsx
import { createAPI } from "./apiFactory";
const adminAPI = createAPI("admin_token", "/admin/login");
export default adminAPI;
